import React from 'react';
import {HashRouter as Router,Routes,Route} from 'react-router-dom';
import {motion} from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Demo from './components/Demo';
import CaseStudiesPreview from './components/CaseStudiesPreview';
import DatabaseReactivation from './components/DatabaseReactivation';
import CallToAction from './components/CallToAction';
import About from './components/About';
import CaseStudies from './components/CaseStudies';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function HomePage() {
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.5}}>
      <Hero />
      <Solutions />
      <Demo />
      <CaseStudiesPreview />
      <DatabaseReactivation />
      <CallToAction />
    </motion.div>
  );
}

function AboutPage() {
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.5}}>
      <About />
    </motion.div>
  );
}

function CaseStudiesPage() {
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.5}}>
      <CaseStudies />
    </motion.div>
  );
}

function ContactPage() {
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.5}}>
      <Contact />
    </motion.div>
  );
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;